import Modal from "../../../../layouts/Modal";
import { ILead } from "../../../../models/Lead";
import SendEmail from "../../../contacts/SendEmail";
import SendText from "../../../contacts/SendText";

export default function ContactModals({
  lead,
  emailOpen,
  textOpen,
  setEmailOpen,
  setTextOpen,
}: {
  lead: ILead;
  emailOpen: boolean;
  textOpen: boolean;
  setEmailOpen: any;
  setTextOpen: any;
}) {
  return (
    <>
      <Modal open={emailOpen} setOpen={setEmailOpen} width="max-w-7xl max-h-[75vh]">
        <label>Send updated quote to customer via email</label>
        <SendEmail lead={lead} setOpen={setEmailOpen} />
      </Modal>

      <Modal open={textOpen} setOpen={setTextOpen} width="max-w-7xl">
        <label>Send updated quote to customer via SMS</label>
        <SendText lead={lead} setOpen={setTextOpen} />
      </Modal>
    </>
  );
}